import React from "react";

const NoData = () => {
  return (
    <>
      <h1>No data found!</h1>
    </>
  );
};

export default NoData;
